export default __webpack_public_path__ + "static/media/section2_pic2.ad8fed9d.webp";